var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('strong',[_c('text-highlight',{attrs:{"queries":_vm.highlight}},[_vm._v(" "+_vm._s(_vm.data.label)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }